import { render, staticRenderFns } from "./DeviceManagementModify.vue?vue&type=template&id=b8cd7976&scoped=true&"
import script from "./DeviceManagementModify.vue?vue&type=script&lang=js&"
export * from "./DeviceManagementModify.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagementModify.vue?vue&type=style&index=0&id=b8cd7976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cd7976",
  null
  
)

export default component.exports